import React from 'react';
import './Loading.scss';

/**
 * 公共 Loading 组件
 * @param {string} text - 加载文字，默认 "加载中..."
 * @param {string} size - 尺寸 small / default / large
 */
function Loading({ text = '加载中...', size = 'default' }) {
  return (
    <div className={`loading loading--${size}`}>
      <div className="loading-spinner" />
      {text && <span className="loading-text">{text}</span>}
    </div>
  );
}

export default Loading;
